import { createContext, useContext } from 'react';

import type { OrgDashboardApiOrg } from 'modules/orgDashboard/api/types/OrgDashboardApiOrg';

export type OrgDashboardOrgContextState = {
  org: OrgDashboardApiOrg;
  setOrg: (updatedOrg: OrgDashboardApiOrg) => void;
  reloadOrg: () => Promise<void>;
};

export const OrgDashboardOrgContext =
  createContext<OrgDashboardOrgContextState>({
    org: null as unknown as OrgDashboardApiOrg,
    setOrg: () => {
      throw new Error('Not implemented');
    },
    reloadOrg: () => {
      throw new Error('Not implemented');
    },
  });

export function useOrgDashboardOrgContext() {
  return useContext(OrgDashboardOrgContext);
}
